import { color } from '@primer-io/goat'
import {
	ClipboardCheck,
	CloseCircle,
	CodeClose,
	ExclamationTriangle,
	RotateRight,
	ShoppingBag,
} from '@primer-io/goat-icons'
import * as ArticleComponents from 'components/ArticleComponents'

import {
	FullWidthGuide,
	GuideLink,
	Header,
	OverviewSection,
	OverviewTopSection,
	SmallGuideLink,
} from 'components/OverviewComponents'
import Grid from 'ds/Grid'
import React from 'react'

import CoverImg from './assets/cover.png'
import DropInImg from './assets/drop-in.png'
import HeadlessCheckoutImg from './assets/headless-checkout.png'
import NotificationImg from './assets/notification.png'
import ProcessPaymentsImg from './assets/process-payments.png'

import { featureGuides } from './data'

///////////////////////////////////////////
// Root
///////////////////////////////////////////

const PaymentsOverview = () => {
	return (
		<ArticleComponents.Wrapper>
			<OverviewSection>
				<OverviewTopSection
					title='Payments'
					description={
						<>
							<ArticleComponents.P>
								Consolidate your payment stack and create great payment experiences.
							</ArticleComponents.P>
						</>
					}
					imgSrc={CoverImg}
				/>
			</OverviewSection>

			<OverviewSection>
				<FullWidthGuide
					title='Process payments'
					description='Primer brings together all your preferred payment services in a single, easy-to-implement integration.'
					imgSrc={ProcessPaymentsImg}
					imgBackground={color('lilac-100')}
					buttonContent='Get started'
					to={'./process-payments'}
				/>
			</OverviewSection>

			<OverviewSection>
				{/* Flexibility */}
				<Header>Build the way you want</Header>
				<Grid cols={{ md: 2, lg: 2, xl: 2 }} gap={24} style={{ marginTop: 24 }}>
					<GuideLink
						title='Drop-in Checkout'
						description='Embed our Checkout UI into your platform which can be customized to your requirements.'
						link='./universal-checkout/drop-in/get-started'
						imgSrc={DropInImg}
						coverAspectRatio={2.2}
						tag='Low Code'
					/>
					<GuideLink
						title='Headless Checkout'
						description='Integrate our UI components into your platform and have full control over the design and flow.'
						link='./universal-checkout/headless/get-started'
						imgSrc={HeadlessCheckoutImg}
						coverAspectRatio={2.2}
						tag='Fully Customizable'
					/>
				</Grid>
			</OverviewSection>

			<OverviewSection>
				{/* In a unified way */}
				<Header>Manage payments</Header>

				<Grid cols={{ md: 2, lg: 2, xl: 4, sm: 2 }} gap={24} style={{ margin: '24px 0px' }}>
					<SmallGuideLink title='Capture' to='./capture-payments' icon={ClipboardCheck} />
					<SmallGuideLink title='Cancel' to='./cancel-payments' icon={CloseCircle} />
					<SmallGuideLink title='Refund' to='./refund-payments' icon={RotateRight} />
					<SmallGuideLink title='Disputes' to='./manage-disputes' icon={ExclamationTriangle} />
				</Grid>
			</OverviewSection>

			<OverviewSection>
				<FullWidthGuide
					title='Receive payment notifications'
					// why would you do it
					description='Primer Payment supports server notifications via webhooks to give you visibility on the status of your payments.'
					imgSrc={NotificationImg}
					imgBackground={color('green-200')}
					buttonContent='Configure webhooks'
					to='./webhooks'
				/>
			</OverviewSection>

			<OverviewSection>
				<Header>Learn more about Primer Payments</Header>
				<Grid cols={{ md: 2, lg: 3, xl: 3, sm: 1 }} gap={24} style={{ margin: '24px 0px' }}>
					{featureGuides.map(({ title, description, link, imgSrc }) => (
						<GuideLink
							key={title}
							title={title}
							description={description}
							link={link}
							imgSrc={imgSrc}
							coverAspectRatio={1.829}
						/>
					))}
				</Grid>
			</OverviewSection>
		</ArticleComponents.Wrapper>
	)
}

export default PaymentsOverview
